var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"pss__button",class:_vm.disabled ? 'disabled' : '',attrs:{"to":_vm.to ? _vm.to : ''}},[_c('span',{on:{"click":_vm.emitClick}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }